/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownFlag } from '../models/db_DropdownFlag';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Flags {
    /**
     * Get a list of flags
     * @returns db_DropdownFlag OK
     * @throws ApiError
     */
    public static listFlags(): CancelablePromise<Array<db_DropdownFlag>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/flags',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
